
import { useParams } from "react-router-dom";
import CampusInfo from "../components/about_us/CampusInfo";
import TopTitle from "../components/TopTitle";
import data from "../constants/campus.json";
import careers from "../constants/careers.json";

function Campus() {
  const params = useParams();
  const campus = data[params.id];
  const image = require(`../assets/img/iuta-${params.id}.jpg`);

  return (
    <div className="main-content">
      <TopTitle title={campus.name} />
      <CampusInfo campus={campus} careers={careers} image={image} />
    </div>
  );
}

export default Campus;
